import React from 'react'
import { LayerReport } from '../../domain/TraceSummary'
import Milliseconds from '../../helper/milliseconds'
import Percent from '../../helper/percent'
import LargeNumber from '../../helper/large-number'
import { BoxBody } from '../../ui/box'
import { layersNameToClass, layersNameToLabel, layersLayerSupportsCount } from '../../domain/Layers'

type Props = {
    layerReport: LayerReport
    wt: number
}

export class TraceDetailsLayerReport extends React.PureComponent<Props> {
    render() {
        const { layerReport, wt } = this.props
        return (
            <BoxBody>
                <div className="traceLayerReport tw-font-size-16 tw-mb-8">
                    <div className="traceLayerReport-header">Layer</div>
                    <div className="traceLayerReport-header">Calls</div>
                    <div className="traceLayerReport-header">Response</div>
                    <div className="traceLayerReport-header">% of Total</div>

                    {Object.keys(layerReport)
                        .map(layer => ({ layer, ...layerReport[layer] }))
                        .sort((a, b) => b.wt - a.wt)
                        .map(report => (
                            <React.Fragment key={report.layer}>
                                <div className="text-ellipsis">
                                    <small className="tw-mr-8">{layersNameToLabel(report.layer)}</small>
                                </div>
                                <div className="text-ellipsis">
                                    {layersLayerSupportsCount(report.layer) ? (
                                        <LargeNumber value={report?.ct ?? 0} class={layersNameToClass(report.layer)} />
                                    ) : (
                                        <div className="text-muted">-</div>
                                    )}
                                </div>
                                <div>
                                    <Milliseconds value={report?.wt ?? 0} class={layersNameToClass(report.layer)} />
                                </div>
                                <div>
                                    <Percent value={report.wt / wt} class={layersNameToClass(report.layer)} />
                                </div>
                            </React.Fragment>
                        ))}
                </div>
                <hr />
            </BoxBody>
        )
    }
}
